module.exports = __webpack_public_path__ + "img/bht_clinics.adcbb2c9.jpg";